import "reflect-metadata";
import {inject, injectable} from "inversify";
import {NoticesRepository} from "@dropDesk/domain/repositories/notices/notices.repository";
import {NoticesEntity} from "@dropDesk/domain/entities/notices/notices.entity";

@injectable()
export class RestoreNoticesUseCase {
  private _repository: NoticesRepository;

  constructor(@inject(NoticesRepository) repository: NoticesRepository) {
    this._repository = repository;
  }

  public call(notices: NoticesEntity[]): Promise<void> {
    return this._repository.restore(notices);
  }
}
